<!--
 * @Author: hcw
 * @Date: 2022-08-24 15
-->
<!--
 * @Author: your name
 * @Date: 2022-05-30 17
-->
<!-- 查看更多 -->
<template>
  <div class="examineMore-box" @click="examine()">
    <div v-if="!moreLoading" class="ckgd">{{'查看更多'}}</div>
    <div v-else class="ckgd no-cursor">{{'加载中...'}}</div>
    <div class="examineMore" v-if="!moreLoading">
      <div class="ckgd-icon el-icon-arrow-down"></div>
    </div>
  </div>
</template>
<script>
export default {
  props:{
    moreLoading:{
      type:Boolean,
      default:false
    }
  },
  methods:{
    examine(){
      this.$emit('examine')
    },
  }
}

</script>
<style lang="scss" scoped>
.examineMore-box{
  padding: 20px 0;
}
.examineMore{
  display: flex;
  justify-content: center;
  cursor: pointer;
}
.ckgd{
  text-align: center;
  font-size: 14px;
  color: #000000;
  margin-top: 25px;
  cursor: pointer;
}
.no-cursor{
  cursor:default
}
.ckgd-icon{
  font-size: 26px;
  color: #AFAFAF;
  margin: 0 auto;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/examineMore.vue